<template>
	<div class="khbIM">
		<!--缩略聊天图标-->
		<!--登录-->
		<transition name="bounce">
			<!-- v-show="loginShow" -->
			<div class="loginShow" v-show="loginShow">
				<login ref="myimshow"></login>
			</div>
		</transition>
		<!--聊天-->
		<transition name="bounce">
			<div v-bind:class="{ wrapIM: !zoom , wrapIMbg : zoom}" v-show="wrapIMshow" ref='dragBox'
				style="z-index: 1000;">
				<div class="left-userList">
					<div class="search">
						<el-input v-model="searchVal" @focus="focusgo()" placeholder="请输入群号、频道或名称"></el-input>
						<i class="el-icon-edit el-input__icon"></i>
					</div>
					<!--添加群组频道-->
					<transition name="fade">
						<div v-if="searchShow" class="searchWrap">
							<div class="addsc">
								<span>
									添加群组、频道
								</span>
								<i class="el-icon-close" @click="guanbi"></i>
							</div>
							<div class="addQun">
								<ul>
									<li v-for="(item,index) in searchData" :key="index">
										<div v-if="item.group_no!=undefined">
											<img :src="item.group_logo" />
											<span>{{item.group_title}}</span>
											<button @click="check(item)">添加群</button>
										</div>
										<div v-else>
											<img :src="item.channel_logo" />
											<span>{{item.channel_title}}</span>
											<button @click="check(item)">添加频道</button>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</transition>
					<!--左侧群频道列表-->
					<div class="box">
						<img src="../../assets/img/listqun.png" v-if="listDataShow" class="noNews" />
						<div class="chatItem van-hairline--bottom" v-bind:class="{active: isActive==index}"
							v-for="(item,index) in listData" :key="index" @click="gopage(item,index)">

							<div class="head">
								<img src="../../assets/img/q2.fw.png" v-if="item.ms_type=='0'" class="ig" />
								<img src="../../assets/img/q1.fw.png" v-if="item.ms_type=='1'" class="ig" />
								<img src="../../assets/img/q3.fw.png" v-if="item.ms_type=='2'" class="ig" />
								<img :src="item.ms_logo" />
							</div>

							<div class="cont">
								<p class="name" v-html="$options.filters.msTitle(item.ms_title)"></p>
								<p v-if="item.ms_msg.biz_type=='TEXT'" v-html="item.ms_msg.msg_content.content"
									class="msg"></p>
								<p v-if="item.ms_msg.biz_type=='VIDEO_FILE'" class="msg">[视频]</p>
								<p v-if="item.ms_msg.biz_type=='PIC_FILE'" class="msg">[图片]</p>
								<p v-if="item.ms_msg.biz_type=='NOTICE'" class="msg">[加群通知]</p>
								<p v-if="item.ms_msg.biz_type=='COUPON'" class="msg">[优惠券]</p>
								<p v-if="item.ms_msg.biz_type=='PIC_FILES'" class="msg">[图片]</p>
								<p v-if="item.ms_msg.biz_type=='GOODS'" class="msg">{{item.ms_msg.msg_content.title}}
								</p>
								<p v-if="item.ms_msg.biz_type=='MUSIC'" class="msg">[音乐]</p>

							</div>

							<div class="time">{{item.ms_time | timestamp}}</div>
							<span class="unromves" @click.stop="unromve(item)">删除</span>




						</div>

					</div>
				</div>
				<div class="right-userList">
					<!--设置充值-->
					<div class="top-userTitle" @mousedown="drag">
						<div class="left">
							<img :src="isUser.ms_logo" v-if="isUser.ms_logo" />
							<span>{{isUser.ms_title}} <i
									v-if="isUser.ms_type!='0'&&isUser!=''">({{isUser.user_count}})</i></span>
						</div>
						<div class="right">
							<ul>
								<li>
									<span
										style="display: block;line-height: 1.4;font-weight: bold;font-size: 15px;color: #F56C6C;"
										@click="topUps_show=true">充值</span>
								</li>
								<li>
									<span
										style="    display: block;line-height: 1.4;font-weight: bold;font-size: 15px;color: #F56C6C;"
										@click="jifen()">积分</span>
								</li>
								<!-- <li>
									<span
										style="    display: block;line-height: 1.4;font-weight: bold;font-size: 15px;color: #F56C6C;"
										@click="ungo()">退出</span>
								</li> -->
								<li v-if="isUser.ms_type=='1'">
									<span class="el-icon-setting" v-if="!setUpShow" @click="playgo()"></span>
									<span class="el-icon-error" v-else="" @click="setUpShow=false"></span>

								</li>
								<li @click="zoom=!zoom">
									<span class="icon iconfont" v-show="zoom">&#xe659;</span>
									<span class="icon iconfont" v-show="!zoom">&#xe676;</span>
								</li>

								<!-- 隐藏x号 -->
								<!-- <li  @click="wrapIMshow=false">
		    					<span class="icon iconfont">&#xe601;</span>
		    				</li> -->
							</ul>
						</div>
						<div v-if="!isUser.ms_logo"
							style=" height: 110px; background-color: rgba(245,245,245,.7); width: 100%;"></div>
						<div v-if="!xianshi"
							style=" height: 110px; background-color: rgba(245,245,245,.7); width: 100%;"></div>
						<div v-if="isUser.ms_logo && xianshi"
							style=" height: 110px; background-color: rgba(245,245,245,.7); width: 100%;">
							<div style="width: 100%;overflow: hidden;
						white-space: nowrap;">
								<div style="font-size: 14px;display: inline-block;padding-left: 20px;">机器人唤醒词：</div>
								<div v-for='(item,index) in jiqiren'
									style="cursor:pointer;height: 20px; line-height: 20px;margin-left: 5px;display: inline-block;font-size: 12px;border-radius: 5px; color: #409EFF; border: 1px #409EFF solid; padding: 0 5px;"
									@click='getgjc(item.word)'>{{item.word}}</div>
								<div style="cursor:pointer;height: 20px; line-height: 20px;margin-left: 10px;display: inline-block;border: 1px #409EFF solid; padding: 0 5px;border-radius: 5px; color: #409EFF;font-size: 12px;"
									@click='zhanshijiqi'>更多...</div>

							</div>
							<div style=" margin-left: 20px; margin-top:5px;cursor:pointer;height: 20px; line-height: 20px;display: inline-block;border: 1px #228B22 solid;width: 80px; text-align: center; border-radius: 5px; color: #228B22;font-size: 12px;"
								@click='yibdjiqi'>已绑定机器人</div>

							<div style=" margin-left: 20px; margin-top:5px;cursor:pointer;height: 20px; line-height: 20px;display: inline-block;border: 1px #F56C6C solid;width: 80px; text-align: center; border-radius: 5px; color: #F56C6C;font-size: 12px;"
								@click='bdjiqi'>绑定机器人+</div>

						</div>
					</div>

					<transition>
						<div v-show="jiqishow" style="
						position: absolute;
						z-index: 1000;
						width: 100%;
						height: 200px;
						border-top: 1px #DFDFDF solid;
						background: #ECECEC;
						overflow: hidden;
					">
							<div style="text-align: right; font-size: 20px;"><i class="el-icon-close"
									style="margin-right: 10px;" @click='jiqishow=false'></i></div>
							<div style="display: inline-block; margin-top: 10px;" v-for="(item,index) in aihuanxingci"
								@click="aigo(item.word)">
								<!-- <h1>{{item.word}}</h1> -->
								<div
									style="cursor:pointer; height: 30px; line-height: 30px; margin-left: 5px;font-size: 12px;border-radius: 5px; color: #409EFF; border: 1px #409EFF solid; padding: 0 5px;">
									{{item.word}}</div>
							</div>

						</div>
					</transition>
					<transition name="el-zoom-in-bottom">
						<div v-show="bindAIShow" class="transition-box aibox">
							<div class="aititle">
								<div style="text-align: center;background: #ECECEC;height: 32px;line-height: 32px;">
									<b style="font-size: 14px;">机器人列表</b>
									<div @click="bindAIShow=!bindAIShow" style="float: right;width: 20px;"><i
											class="el-icon-close"></i></div>
								</div>

							</div>
							<div class="aiRon">
								<div class="aiItem aiItemb" v-for="(item,index) in bindNoData">
									<img style="height: 60px;width: 60px;" :src="item.app_logo" />
									<h6 style="overflow: hidden;
													 white-space: nowrap;
													 text-overflow:ellipsis;">{{item.app_title}}</h6>
									<el-button round @click="bangding(item)">绑定</el-button>
								</div>
							</div>
						</div>
					</transition>
					<transition name="el-zoom-in-bottom">
						<div v-show="yibindAIShow" class="transition-box aibox">
							<div class="aititle">
								<div style="text-align: center;background: #ECECEC;height: 32px;line-height: 32px;">
									<b style="font-size: 14px;">已绑定机器人列表</b>
									<div @click="yibindAIShow=!yibindAIShow" style="float: right;width: 20px;"><i
											class="el-icon-close"></i></div>

								</div>

							</div>
							<div v-if="jiqi==''" style="font: 14px; color: #666; width: 100%; text-align: center;">
								暂时没有绑定的机器人</div>
							<div class="aiRon">
								<div class="aiItem aiItemb" v-for="(item,index) in jiqi">
									<img style="height: 60px;width: 60px;" :src="item.app_logo" />
									<h6 style="overflow: hidden;
													 white-space: nowrap;
													 text-overflow:ellipsis;">{{item.app_title}}</h6>
									<el-button round @click="jiebang(item)" v-if="item.app_status=='0'">解除绑定</el-button>
									<el-button type="danger" round v-if="item.app_status=='1'">异常</el-button>
								</div>
							</div>
						</div>
					</transition>
					<!--聊天窗口-->
					<div class="center-userMsg">
						<chat ref="chat"></chat>
						<div class="hdtp" v-if="hdtpShow">
							<img src="../../assets/img/hd.png" />
						</div>
						<transition name="fadeSetUp">
							<set-up ref='setUp' v-show="setUpShow"></set-up>
						</transition>
						<transition name="fadeSetUp">
							<top-ups :chongzhi='chongzhi' :goto="goto" v-if="topUps_show"></top-ups>
						</transition>
						<transition name="fadeSetUp">
							<top-ups-yemx :chongzhi='chongzhi' v-if="topUps_yemx_show"></top-ups-yemx>
						</transition>
						<transition name="fadeSetUp">
							<top-ups-czmx :chongzhi='chongzhi' v-if="top_ups_czmx "></top-ups-czmx>
						</transition>
						<transition name="fadeSetUp">
							<top-ups-cz :chongzhi='chongzhi' v-if="top_ups_cz"></top-ups-cz>
						</transition>
					</div>
				</div>

			</div>
		</transition>
		<audio ref="audio" hidden src="../../static/4082.mp3"></audio>


		<el-dialog :title="wayData" :visible="dialogVisible.show" width="40%">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="密钥" prop="qunPass" v-if="dialogVisible.num=='2'">
					<el-input v-model="ruleForm.qunPass" placeholder="请输入加群密钥"></el-input>
				</el-form-item>
				<el-form-item label="邀请人" prop="qunUser" v-if="dialogVisible.num=='3'">
					<el-input v-model="ruleForm.qunUser" placeholder="请输入邀请人"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>




	</div>
</template>

<script>
	import login from "@/components/im/loginIm"
	import chat from "@/components/im/chatIm"
	import setUp from "@/components/im/setUp"
	import topUps from "@/components/im/topUps"
	import topUpsYemx from "@/components/im/topUpsYEMX"
	import topUpsCzmx from "@/components/im/topUpsCZMX"
	import topUpsCz from "@/components/im/topUpsCZ"

	//import draggable from 'vuedraggable'	
	import { Base64 } from '@/xiaomi/Base64.js';
	import { getMimcInfo } from '@/xiaomi/mimc.js';
	import qs from "qs"
	var that = null;
	var bell = true;
	export default {
		// inject: ['reload'], // 引入方法
		components: {
			login,
			chat,
			setUp,
			topUps,
			topUpsYemx,
			topUpsCzmx,
			topUpsCz
		},
		data() {
			return {
				dialogVisible: {
					show: false,
					num: '2'
				},
				lastTime: 0,//默认上一次点击时间为0   
				fadeShow: true,
				wrapIMshow: false,
				searchVal: '',
				zoom: false,
				loginShow: false,
				listData: [],
				wayData: '',
				hiddenmodalput: false,
				answer: '',
				sp: '',
				listDataShow: false,
				isActive: '5fhgjk',
				isUser: [],
				qunma: '',// 群id
				jiqi: [],//关联的机器人
				jiqiren: [],//截取四个
				jiqishow: false,
				bindAIShow: false,
				yibindAIShow: false,
				bindNoData: [],//查询未绑定的机器人
				aihuanxingci: [],//机器人唤醒词
				ms_typepd: '',
				hdtpShow: true,
				searchShow: false,
				xianshi: true,
				searchData: [],
				addgroup_no: '',
				ruleForm: {
					qunPass: '',
					qunUser: '',
				},
				rules: {
					qunPass: [
						{ required: true, message: '请输入加群密钥', trigger: 'blur' },
					],
					qunUser: [
						{ required: true, message: '请输入邀请人', trigger: 'blur' }
					]
				},
				setUpData: [],
				setUpShow: false,
				topUps_show: false,
				topUps_yemx_show: false,
				top_ups_czmx: false,
				top_ups_cz: false,

				linshidata: {}
			}
		},
		created: function () {

			var that = this
			if (this.user == null) {
				if (!this.login) {
					//登录
				} else {

					getMimcInfo(this.getCookie("phoneIm"), function (item) {
						that.user.registerUCMsgHandler(that.ucMessage);
						that.user.registerP2PMsgHandler(that.receiveP2PMsg);
						that.user.registerGroupMsgHandler(that.receiveP2TMsg)
						that.user.registerServerAckHandler(that.serverAck);
						that.user.registerDisconnHandler(that.disconnect);
						that.getList()
					})
				}
			} else {
				that.user.registerUCMsgHandler(that.ucMessage);
				that.user.registerP2PMsgHandler(that.receiveP2PMsg);
				that.user.registerGroupMsgHandler(that.receiveP2TMsg)
				that.user.registerServerAckHandler(that.serverAck);
				that.user.registerDisconnHandler(that.disconnect);
				this.getList()
			}

		},
		computed: {
			user() {
				return this.$store.state.user
			},
			login() {
				return this.$store.state.loginTrue
			}
		},
		watch: {
			// listData() {
			// //   this.timer();
			// this.getList()
			// },
			zoom: function () {
				if (this.zoom) {
					this.stop()
				} else {
					this.move()
				}
				let odiv = this.$refs.dragBox;
				odiv.style.left = '';
				odiv.style.top = '';
			},
			wrapIMshow: function () {

				if (this.wrapIMshow) {
					if (this.zoom) {
						this.stop()
					} else {
						this.move()
					}
				} else {
					this.move()
				}
				let odiv = this.$refs.dragBox;
				odiv.style.left = '';
				odiv.style.top = '';

			},
			searchVal: function () {
				if (this.searchVal == '') {
					return false
				} else {
					//搜索
					this.searchAll()
				}


			}
		},
		methods: {
			//   删除群组
			unromve(item) {
				let getid = item.id + ''
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/v1/removeMsgSession/' + getid)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.linshidata = {}
							this.getList()
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},
			//清除所有cookie
			clearAllCookie() {
				var date = new Date();
				date.setTime(date.getTime() - 10000);
				var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
				if (keys) {
					for (var i = keys.length; i--;) {
						document.cookie = keys[i] + "=0; expire=" + date.toGMTString() + "; path=/";
					}
				}
			},
			//   退出登录
			ungo() {

				localStorage.clear();
				this.clearAllCookie()
				this.wrapIMshow = false
				this.$store.commit('loginTrueFc', false);
				this.listData = []
				this.$router.go(0)
			},
			searchQun() {
				let params = qs.stringify({
					group_longitude: '119.091561',
					group_latitude: '36.69469',
					query_text: this.searchVal,
				})

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				return this.$axios.post('/goods/mimc/v1/queryGroups', params)
			},
			searchPinDao() {
				let params = qs.stringify({
					query_text: this.searchVal,
				})

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				return this.$axios.post('/goods/mimc/channel/v1/queryChannel', params)
			},
			searchAll() {
				this.$axios.all([this.searchQun(), this.searchPinDao()])
					.then(this.$axios.spread((qun, pindao) => {
						var qunData = [];
						var pindaoData = [];
						if (qun.data.resultCode == "0000") {
							//this.searchData=qun.data.resultInfo
							qunData = qun.data.resultInfo
						} else if (qun.data.resultCode == "1313") {
							this.loginto();
						} else {
							this.$message.error(qun.data.resultMsg);
						}


						if (pindao.data.resultCode == "0000") {
							pindaoData = pindao.data.resultInfo
						} else if (pindao.data.resultCode == "1313") {
							this.loginto();
						} else {
							this.$message.error(pindao.data.resultMsg);
						}

						if (qun.data.resultCode == "0000" && pindao.data.resultCode == "0000") {
							this.searchData = qunData.list.concat(pindaoData.list)
						}

					}));
			},
			focusgo() {
				this.searchShow = true
			},
			drag: function (e, index) {
				if (this.zoom) {
					return false
				}
				let odiv = this.$refs.dragBox;   //获取当前元素
				//算出鼠标相对元素的位置
				let disX = e.clientX - odiv.offsetLeft - 400;
				let disY = e.clientY - odiv.offsetTop - 260;
				let left = '';
				let top = '';
				document.onmousemove = (e) => {


					//用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
					left = e.clientX - disX;
					top = e.clientY - disY;
					//绑定元素位置到positionX和positionY上面
					//移动当前元素

					odiv.style.left = left + 'px';
					odiv.style.top = top + 'px';
				};
				document.onmouseup = (e) => {
					document.onmousemove = null;
					document.onmouseup = null;
				};
			},
			stop() {
				var mo = function (e) { e.preventDefault(); };
				document.body.style.overflow = 'hidden';
				document.addEventListener("touchmove", mo, false);//禁止页面滑动
			},
			/***取消滑动限制***/
			move() {
				var mo = function (e) { e.preventDefault(); };
				document.body.style.overflow = '';//出现滚动条
				document.removeEventListener("touchmove", mo, false);
			},
			go() {
				if (!this.login) {
					this.loginShow = true
				} else {
					this.wrapIMshow = true
				}

			},
			mygo() {
				this.$refs.myimshow.myimshows()
				if (!this.login) {
					this.loginShow = !this.loginShow

				} else {
					this.wrapIMshow = !this.wrapIMshow

				}

			},
			mygo1(data) {

				this.$refs.myimshow.myimshows()
				if (!this.login) {
					this.loginShow = true
				} else {
					this.wrapIMshow = true
					if (data != undefined) {

						this.linshidata = data
						this.listData.unshift(this.linshidata)


					}
				}

			},
			loginto() {
				this.setcookie('phoneIm', '')
				this.setcookie('mytokenIm', '')
				this.wrapIMshow = false
				this.loginShow = true

			},
			loginShowClose() {
				this.loginShow = false
			},
			logingo() {
				// this.reload()  // 哪里需要在哪里调用
				this.loginShow = false
				// this.getList()
				this.wrapIMshow = true
				var that = this
				if (this.user == null) {
					if (!this.login) {
						//登录
					} else {
						getMimcInfo(this.getCookie("phoneIm"), function (item) {
							that.user.registerUCMsgHandler(that.ucMessage);
							that.user.registerP2PMsgHandler(that.receiveP2PMsg);
							that.user.registerGroupMsgHandler(that.receiveP2TMsg)
							that.user.registerServerAckHandler(that.serverAck);
							that.user.registerDisconnHandler(that.disconnect);
							that.getList()
						})
					}
				} else {
					that.user.registerUCMsgHandler(that.ucMessage);
					that.user.registerP2PMsgHandler(that.receiveP2PMsg);
					that.user.registerGroupMsgHandler(that.receiveP2TMsg)
					that.user.registerServerAckHandler(that.serverAck);
					that.user.registerDisconnHandler(that.disconnect);
					that.getList()
				}
			},
			// 	timer() {
			//   return setTimeout(() => {
			//     this.getList();   //这个就是我的接口
			//   }, 1000);
			// },
			getlisttime() {
				//获取当前时间的时间戳
				let now = new Date().valueOf();
				//第一次点击
				if (this.lastTime == 0) {
					this.getList()
					this.lastTime = now;
				} else {
					if ((now - this.lastTime) > 2000) {
						//重置上一次点击时间，2000是我自己设置的2秒间隔，根据自己的需要更改
						this.lastTime = now;
						this.getList()
						//添加自己要调用的方法
					} else {
						return false
					}
				}
			},
			getnewlist(data) {
				// console.log(999999, data[0])
				this.listData = data.filter((item, index) => {
					if (item.ms_msg != '' && item.ms_msg != undefined && item.ms_msg != null) {
						item.ms_msg = JSON.parse(item.ms_msg)
					}
					if (item.ms_msg == null) {
						item.ms_msg = {}
						item.ms_msg.msg_content = ''
					}
					if (this.isJson(item.ms_msg.msg_content)) {

						item.ms_msg.msg_content = JSON.parse(item.ms_msg.msg_content)
						if (item.ms_msg.biz_type == 'TEXT') {
							if (item.ms_msg.msg_content.content == undefined) {
								item.ms_msg.msg_content.content = "******"
							} else {
								item.ms_msg.msg_content.content = this.decodeUnicode(item.ms_msg.msg_content.content)

							}

						}
						if (item.ms_msg.biz_type == 'PIC_FILES') {
							item.ms_msg.msg_content.content = this.decodeUnicode(item.ms_msg.msg_content.content)
							if (item.ms_msg.msg_content.imags != undefined) {
								item.ms_msg.msg_content.images = item.ms_msg.msg_content.imags
							}
						}

						if (item.ms_msg.biz_type == 'COUPON') {
							if (item.ms_msg.msg_content.coup_amt != undefined) {
								item.ms_msg.msg_content.images = item.ms_msg.msg_content.imags
							}
						}

					} else {
						if (item.ms_msg.biz_type == 'TEXT') {
							item.ms_msg.msg_content = { content: this.decodeUnicode(item.ms_msg.msg_content) }
						}
						if (item.ms_msg.biz_type == "NOTICE") {
							item.ms_msg.msg_content = { content: item.ms_msg.msg_content }
						}
						if (item.ms_msg.biz_type == "PIC_FILE") {
							item.ms_msg.msg_content = { url: item.ms_msg.msg_content }
						}

					}
					return item
				})
			},

			isEmpty(obj) {
				return Object.keys(obj).length === 0;
			},
			//获取右侧列表
			getList() {
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/v1/queryMsgSession')
					.then(userData => {
						if (userData.data.resultCode == "0000") {
							if (userData.data.resultInfo.length <= 0) {
								this.listDataShow = true
							} else {
								this.listDataShow = false
							}
							var dd = userData.data.resultInfo


							var panduandata = dd.filter((item, index) => {
								return item.kh_account === this.linshidata.kh_account
							})
							if (panduandata.length == 0 && this.isEmpty(this.linshidata) == false) {
								var arr2 = [this.linshidata, ...userData.data.resultInfo];
								// console.log('22', arr2)
								// userData.data.resultInfo.unshift(this.linshidata)
								this.getnewlist(arr2)
								this.gopage(this.linshidata, 0)
							} else {
								this.linshidata = {}
								this.getnewlist(userData.data.resultInfo)
							}

						} else if (userData.data.resultCode == "1313") {
							this.loginto();
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})

			},
			//下拉关闭
			guanbi() {
				this.searchShow = false;
				this.searchVal = '';
				this.searchData = []
			},
			jifen() {
				this.$message("请下载APP查看");
			},
			chongzhi(data) {
				if (data == 'cz') {
					//全部关闭
					this.topUps_show = false;
					this.topUps_yemx_show = false;
					this.top_ups_czmx = false
					this.top_ups_cz = false
				} else {
					this.topUps_show = true;
					this.topUps_yemx_show = false;
					this.top_ups_czmx = false;
					this.top_ups_cz = false
				}


			},
			goto(data) {
				if (data == 'cz') {
					this.top_ups_cz = true
					this.topUps_show = false;
					this.topUps_yemx_show = false;
					this.top_ups_czmx = false;

				} else if (data == 'yemx') {
					this.topUps_yemx_show = true
					this.top_ups_cz = false
					this.topUps_show = false;
					this.top_ups_czmx = false;
				} else if (data == 'czmx') {
					this.top_ups_czmx = true;
					this.topUps_yemx_show = false
					this.top_ups_cz = false
					this.topUps_show = false;
				}
			},
			isJson(str) {
				if (typeof str == 'string') {
					try {
						var obj = JSON.parse(str);
						if (typeof obj == 'object' && obj) {
							return true;
						} else {
							return false;
						}
					} catch (e) {
						return false;
					}
				}
			},
			randomString(len) {
				len = len || 32;
				var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
				var maxPos = $chars.length;
				var pwd = '';
				for (var i = 0; i < len; i++) {
					pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
				}
				return pwd;
			},
			encodeUnicode(str) {
				//加码
				var res = [];
				for (var i = 0; i < str.length; i++) {
					res[i] = ("000" + str.charCodeAt(i).toString(16)).slice(-4);
				}
				return "\\u" + res.join("\\u");
			},
			decodeUnicode(str) {
				str = str.replace(/\\/g, "%"); return unescape(str);
			},
			gopage(data, index) {
				this.$refs.chat.closeQun()
				this.$refs.chat.closesenImg()
				this.setUpShow = false
				this.hdtpShow = false
				this.isActive = index
				if (data.ms_type == '0') {
					this.$refs.chat.qingkong()
					this.xianshi = false
					this.isUser = data
					var to = data.ms_id.split('_')[1]
					this.$refs.chat.goGetInfo({
						ms_type: '0',
						msg_to: to,
						name: data.ms_title,
						user: data.ms_to,
					});
				} else if (data.ms_type == '1') {
					//群

					this.$refs.chat.qingkong()
					this.ms_typepd = data.ms_type
					this.xianshi = true
					this.qunGoPage(data)
				} else if (data.ms_type == '2') {

					this.$refs.chat.qingkong()
					//频道	
					this.xianshi = true
					this.ms_typepd = data.ms_type
					this.pinDaoGoPage(data)

				}
			},
			pinDaoGoPage(data) {
				let params = qs.stringify({
					channel_id: data.ms_to,
				})

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/channel/v1/queryChannelInfo', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.bindAIShow = false
							this.yibindAIShow = false
							this.jiqishow = false
							data.user_count = userData.data.resultInfo.user_count
							this.isUser = data
							this.qunma = userData.data.resultInfo.channel_no
							this.aiHXC()
							this.$refs.chat.goGetInfo({
								ms_type: data.ms_type,
								topId: data.ms_to,
								name: data.ms_title,
								msg_to: userData.data.resultInfo.channel_no,
								user_count: userData.data.resultInfo.user_count
							});
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})

			},
			qunGoPage(data) {
				let params = qs.stringify({
					group_id: data.ms_to,
				})
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/v1/queryGroupInfo', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.bindAIShow = false
							this.yibindAIShow = false
							this.jiqishow = false
							data.user_count = userData.data.resultInfo.user_count
							this.isUser = data
							this.qunma = userData.data.resultInfo.group_no
							this.aiHXC()
							// this.getjiqi(userData.data.resultInfo.group_no)
							this.$refs.chat.goGetInfo({
								ms_type: data.ms_type,
								topId: data.ms_to,
								name: data.ms_title,
								msg_to: userData.data.resultInfo.group_no,
								user_count: userData.data.resultInfo.user_count
							});
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},
			//已绑定的机器人
			getjiqi() {
				let params = qs.stringify({
					group_no: this.qunma
				})
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('goods/mimc/robot/queryRobot/v1', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.jiqi = userData.data.resultInfo
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},
			zhanshijiqi() {
				this.bindAIShow = false,
					this.yibindAIShow = false,
					this.jiqishow = !this.jiqishow
			},
			bdjiqi() {
				this.jiqishow = false,
					this.yibindAIShow = false,
					this.bindAIShow = !this.bindAIShow
				this.bindAI()
			},
			yibdjiqi() {
				this.jiqishow = false,
					this.bindAIShow = false,
					this.yibindAIShow = !this.yibindAIShow
				this.getjiqi()
			},
			bindYes() {
				let params = qs.stringify({
					group_no: this.qunma,
				})
				return this.$axios.post('/goods/mimc/robot/queryRobot/v1', params);
			},
			binNo() {
				return this.$axios.post('/goods/mimc/robot/queryRobotInfos/v1');
			},
			//获取机器人	
			bindAI() {

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.all([this.bindYes(), this.binNo()])
					.then(this.$axios.spread((bindYesInfo, binNoInfo) => {

						if (bindYesInfo.data.resultCode == '0000' && binNoInfo.data.resultCode == '0000') {
							this.bindYesData = bindYesInfo.data.resultInfo
							this.bindNoData = binNoInfo.data.resultInfo
						} else {
							this.$message.error("机器人列表获取失败");
						}
					}));
			},
			//绑定机器人 
			bangding(data) {
				var type = ''
				if (this.ms_typepd == '1') {
					type = 'group'
				} else if (this.ms_typepd == '2') {

					type = 'channel'
				} else {
					return false
				}

				let params = qs.stringify({
					relation_code: data.relation_code,
					group_no: this.qunma,
					type: type
				})

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/robot/relation/v1', params)
					.then(userData => {
						// this.aiHXC()  //机器唤醒词
						if (userData.data.resultCode == '0000') {
							this.$message("绑定成功");
							this.getjiqi(this.qunma)
							this.aiHXC()
						} else {
							this.$message.error(userData.data.resultMsg);
						}
						this.getjiqi()
					}).catch(error => {
						console.log(error)
					})
			},
			//解除绑定机器人
			jiebang(data) {
				let params = qs.stringify({
					id: data.id,
				})

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/robot/unrelation/v1', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.$message("已解除绑定");
						} else {
							this.$message.error(userData.data.resultMsg);
						}
						this.getjiqi()
					}).catch(error => {
						console.log(error)
					})
			},
			//机器人唤醒词
			aiHXC() {
				let params = qs.stringify({
					group_no: this.qunma,
				})

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/robot/getBotWakeWord/v2', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.aihuanxingci = userData.data.resultInfo
							this.jiqiren = this.aihuanxingci.splice(0, 3)
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},
			//调用机器人唤醒词
			getgjc(data) {
				this.jiqishow = false
				this.$refs.chat.tianci(data)
			},
			aigo(data) {
				this.$refs.chat.tianci(data)
			},
			chooseMaster(data) {
				this.setUpShow = false
				this.hdtpShow = false
				this.isUser = data
				this.isActive = '12fgh34'
				this.$refs.chat.goGetInfo(data);

			},
			// 单聊收到消息
			receiveP2PMsg(P2PMsg) {

				var msgData = JSON.parse(P2PMsg.getPayload())
				var msg = Base64.decode(msgData.payload)
				msg = JSON.parse(msg);
				var currenture = new Date().getTime();
				var t = (currenture - msgData.timestamp) / 24 / 60 / 60 / 1000
				if (t >= '1') {
					//过滤除了当天的消息
					return false
				}
				var news = false;
				for (var i = 0; i < this.listData.length; i++) {
					if (P2PMsg.getFromAccount() == this.listData[i].ms_to) {

						news = true
						this.listData[i].ms_msg.biz_type = P2PMsg.getBizType()
						this.listData[i].ms_time = P2PMsg.getTimeStamp()
						if (P2PMsg.getBizType() == 'TEXT') {
							msg.content = this.decodeUnicode(msg.content)
						}
						this.listData[i].ms_msg.msg_content = msg
						var list = this.listData.splice(i, 1)
						this.listData.unshift(list[0])
						this.playSound()
					}
				}
				if (!news) {
					this.getList()
				}

				this.$refs.chat.myP2PMsg(P2PMsg);
			},
			//   群聊收到消息
			receiveP2TMsg(P2TMsg) {

				//群聊
				var msgData = JSON.parse(P2TMsg.getPayload())
				var msg = Base64.decode(msgData.payload)
				msg = JSON.parse(msg);
				var currenture = new Date().getTime();
				var t = (currenture - msgData.timestamp) / 24 / 60 / 60 / 1000
				if (t >= '1') {
					//过滤除了当天的消息
					return false
				}
				for (var i = 0; i < this.listData.length; i++) {
					if (P2TMsg.getTopicId() == this.listData[i].ms_to) {
						this.playSound()
						this.listData[i].ms_msg.biz_type = P2TMsg.getBizType()
						this.listData[i].ms_time = P2TMsg.getTimeStamp()
						if (P2TMsg.getBizType() == 'TEXT') {
							msg.content = this.decodeUnicode(msg.content)
						}
						this.listData[i].ms_msg.msg_content = msg
						var list = this.listData.splice(i, 1)
						this.listData.unshift(list[0])
					}
				}

				this.$refs.chat.myP2TMsg(P2TMsg);
				return setTimeout(() => {
					this.getlisttime()
				}, 1000);

			},
			//   频道接收消息回调
			ucMessage(groupMsg) {
				var msgData = JSON.parse(groupMsg.getPayload())
				var msg = Base64.decode(msgData.payload)
				msg = JSON.parse(msg);
				var currenture = new Date().getTime();
				var t = (currenture - msgData.timestamp) / 24 / 60 / 60 / 1000
				if (t >= '1') {
					//过滤除了当天的消息
					return false
				}
				for (var i = 0; i < this.listData.length; i++) {
					if (groupMsg.getTopicId() == this.listData[i].ms_to) {

						/*开启关闭通知*/
						if (localStorage.getItem('thongzhiData') != undefined) {
							var arr = JSON.parse(localStorage.getItem('thongzhiData'))
							var is = true;
							var indexdata = 0;
							arr.filter((item, index) => {
								if (groupMsg.getTopicId() == item) {
									is = false
									indexdata = index
								}
							})

							if (is) {
								this.playSound()
							}
						}
						this.listData[i].biz_type = groupMsg.getBizType()
						this.listData[i].ms_time = groupMsg.getTimeStamp()
						if (groupMsg.getBizType() == 'TEXT') {
							this.listData[i].ms_msg.msg_content.content = this.decodeUnicode(msg.content)

						}
						var list = this.listData.splice(i, 1)
						this.listData.unshift(list[0])
					}
				}

				this.$refs.chat.ucMessage(groupMsg);
			},
			serverAck(packetId, sequence, timeStamp, errMsg) {

			},
			disconnect() {
				var that = this;
				getMimcInfo(that.getCookie("phoneIm"), function (item) {
					that.user.registerUCMsgHandler(that.ucMessage);
					that.user.registerP2PMsgHandler(that.receiveP2PMsg);
					that.user.registerGroupMsgHandler(that.receiveP2TMsg)
					that.user.registerServerAckHandler(that.serverAck);
					that.user.registerDisconnHandler(that.disconnect);

				})






			},
			playSound() {
				if (bell) {
					bell = false
					this.$refs.audio.play()
					setTimeout(() => {
						bell = true
					}, 3000)
				}

			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.sp = this.ruleForm.qunUser
						this.answer = this.ruleForm.qunPass
						this.add()
					} else {
						return false;
					}
				});
			},
			pinDaoDingYue(data) {
				let params = qs.stringify({
					channel_no: data.channel_no,
					sp: '',
				})

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/channel/v1/subscribe', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.$message("订阅成功");
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})


			},
			cardbox(data) {
				if (data.msg_content.type == '0') {
					//群
					this.cardboxqunGoPage(data)
				} else if (data.msg_content.type == '1') {
					//频道
					this.cardboxPindao(data)
				}
			},
			cardboxqunGoPage(data) {
				let params = qs.stringify({
					group_no: data.msg_content.info.account,
				})
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/v1/queryGroupInfo', params)
					.then(userData => {

						if (userData.data.resultCode == '0000') {
							this.cardboxgetQunList(userData.data.resultInfo)
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},
			cardboxgetQunList(data) {
				var type = 'group'
				let params = qs.stringify({
					group_type: type,
				})
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/v1/queryMyGroups', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							var go = true
							var arr = []
							arr = userData.data.resultInfo.my.concat(userData.data.resultInfo.in)
							arr.filter((item) => {
								if (item.group_no == data.group_no) {
									go = false
									this.isActive = 'pokmk'
									data.ms_to = item.group_id
									data.ms_title = item.group_name
									data.ms_logo = item.group_logo
									data.ms_type = '1'
									this.isUser = data

									this.$refs.chat.goGetInfo({
										ms_type: '1',
										topId: data.ms_to,
										name: data.ms_title,
										msg_to: item.group_no,
										user_count: ''
									});
								}
							})

							if (go) {
								this.cardboxcheck(data)
							}
						} else {
							this.$message.error(userData.data.resultMsg);
						}

					}).catch(error => {

						console.log(error)
					})
			},
			cardboxcheck(data) {
				var jsons = {}
				jsons.group_logo = data.group_logo
				jsons.group_title = data.group_title
				jsons.group_id = data.group_id
				jsons.group_no = data.group_no
				jsons.user_count = data.user_count

				this.addgroup_no = jsons
				let params = qs.stringify({
					group_no: data.group_no,
				})
				this.$axios.post('/goods/mimc/v1/joinGroupWay', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							if (userData.data.resultInfo.group_way == '1') {
								this.add()
							} else
								if (userData.data.resultInfo.group_way == '2') {
									//密钥入驻
									this.wayData = userData.data.resultInfo.way_data
									this.dialogVisible.show = true
									this.dialogVisible.num = '2'
								} else
									if (userData.data.resultInfo.group_way == '3') {
										//只允许群成员邀请入群
										this.wayData = '请输入邀请人编码'
										this.dialogVisible.show = true
										this.dialogVisible.num = '3'
									}
						} else if (userData.data.resultCode == "1313") {
							this.loginto();
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},
			cardboxPindao(data) {
				let params = qs.stringify({
					channel_no: data.msg_content.info.account,
					sp: '',
				})

				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/channel/v1/subscribe', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.cardboxPindaoGo(data)
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})


			},
			cardboxPindaoGo(data) {
				let params = qs.stringify({
					channel_no: data.msg_content.info.account,
				})
				this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
				this.$axios.post('/goods/mimc/channel/v1/queryChannelInfo', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							data.user_count = userData.data.resultInfo.user_count
							data.ms_to = userData.data.resultInfo.channel_id
							data.ms_title = userData.data.resultInfo.channel_title
							data.ms_logo = userData.data.resultInfo.channel_logo
							data.ms_type = '2'
							this.isUser = data
							this.isActive = 'pokmk'
							this.$refs.chat.goGetInfo({
								ms_type: '2',
								topId: data.ms_to,
								name: data.ms_title,
								msg_to: userData.data.resultInfo.channel_no,
								user_count: userData.data.resultInfo.user_count
							});
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},
			check(data) {
				//频道
				if (data.channel_no != undefined) {
					this.pinDaoDingYue(data)

					return false
				}
				//判断进群条件
				this.addgroup_no = data
				let params = qs.stringify({
					group_no: data.group_no,
				})
				this.$axios.post('/goods/mimc/v1/joinGroupWay', params)
					.then(userData => {

						if (userData.data.resultCode == '0000') {
							if (userData.data.resultInfo.group_way == '1') {
								this.add()
							} else
								if (userData.data.resultInfo.group_way == '2') {
									//密钥入驻
									this.wayData = userData.data.resultInfo.way_data
									this.dialogVisible.show = true
									this.dialogVisible.num = '2'
								} else
									if (userData.data.resultInfo.group_way == '3') {
										//只允许群成员邀请入群
										this.wayData = '请输入邀请人编码'
										this.dialogVisible.show = true
										this.dialogVisible.num = '3'
									}
						} else if (userData.data.resultCode == "1313") {
							this.loginto();
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},
			//加群
			add() {
				var data = this.addgroup_no
				let params = qs.stringify({
					group_no: data.group_no,
					sp: this.sp,
					answer: this.answer,
				})
				this.$axios.post('/goods/mimc/v1/joinGroup', params)
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.hdtpShow = false
							this.isUser = {
								ms_type: '1',
								ms_logo: data.group_logo,
								ms_title: data.group_title,
								ms_to: data.group_id,
								ms_time: '123455',
								ms_msg: {
									msg_to: data.group_no,
									biz_type: 'NOTICE'
								},
								user_count: data.user_count
							}

							this.$refs.chat.goGetInfo({
								ms_type: '1',
								topId: data.group_id,
								name: data.group_title,
								msg_to: data.group_no,

							});
							this.listData.push(this.isUser)
							this.dialogVisible.show = false
							this.isActive = 0
							this.$message("添加成功");
						} else if (userData.data.resultCode == "1313") {
							this.loginto();
						} else {
							this.$message.error(userData.data.resultMsg);
						}
					}).catch(error => {
						console.log(error)
					})
			},

			getQunData() {
				let params = qs.stringify({
					group_no: this.isUser.ms_msg.msg_to,
				})
				return this.$axios.post('/goods/mimc/v1/queryGroupInfo', params);
			},
			getQunMember() {
				let params = qs.stringify({
					group_no: this.isUser.ms_msg.msg_to,
				})
				return this.$axios.post('/goods/mimc/v1/queryGroupsMembers', params);
			},
			playgo() {
				this.$axios.all([this.getQunData(), this.getQunMember()])
					.then(this.$axios.spread((qunData, memberData) => {
						if (qunData.data.resultCode == "0000" && memberData.data.resultCode == "0000") {
							this.setUpData = { qunData: qunData.data.resultInfo, memberData: memberData.data.resultInfo }

							this.$refs.setUp.getInfo({
								setUpData: this.setUpData
							});
							this.setUpShow = true

						} else if (userData.data.resultCode == "1313") {
							this.loginto();
						} else {
							this.$message.error("数据获取失败");
						}


					}));
			},
			tuiChu(group_no) {
				this.listData.filter((item, index) => {
					if (item.ms_msg.msg_to == group_no) {
						this.listData.splice(index, 1)
					}
				})
				this.isActive = 'fhfgder32'
				this.hdtpShow = true
				this.isUser = []
				this.setUpShow = false
			},
			setcookie(name, value) {
				//设置名称为name,值为value的Cookie
				var expdate = new Date();   //初始化时间
				expdate.setTime(expdate.getTime() + 24 * 7 * 60 * 60 * 1000);   //时间单位毫秒 过期时间30分钟
				document.cookie = name + "=" + value + ";expires=" + expdate.toGMTString() + ";path=/";

				//即document.cookie= name+"="+value+";path=/";  时间默认为当前会话可以不要，但路径要填写，因为JS的默认路径是当前页，如果不填，此cookie只在当前页面生效！
			},
			getCookie(c_name) {
				//判断document.cookie对象里面是否存有cookie
				if (document.cookie.length > 0) {
					var c_start = document.cookie.indexOf(c_name + "=")
					//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
					if (c_start != -1) {
						c_start = c_start + c_name.length + 1
						var c_end = document.cookie.indexOf(";", c_start)
						if (c_end == -1) c_end = document.cookie.length
						return unescape(unescape(document.cookie.substring(c_start, c_end)))
					}
				}
				return ""
			},

		},

		mounted: function () {

			setTimeout(() => {
				this.fadeShow = false
			}, 4000)
		},
		filters: {
			msTitle(data) {
				if (data != undefined) {
					if (data.length > 8) {
						return data.substring(0, 8) + '...'
					} else {
						return data
					}
				}

			},
			timestamp(data) {
				data = data + ''
				if (data.indexOf('-') != '-1') {
					let d = new Date(data)
					data = d.getTime(d)
				}

				var dateCurrent = new Date();
				var yCurrent = dateCurrent.getFullYear();
				var mCurrent = dateCurrent.getMonth() + 1;
				var dCurrent = dateCurrent.getDate();
				var date = new Date(parseInt(data));//时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear();
				var M = date.getMonth() + 1;
				var D = date.getDate();
				var h = date.getHours();
				var m = date.getMinutes();
				var s = date.getSeconds();
				if (Y == yCurrent && M == mCurrent && D == dCurrent) {
					if (h < 10) {
						h = '0' + h
					}
					if (m < 10) {
						m = '0' + m
					}
					return h + ":" + m;
				} else if (Y == yCurrent && M == mCurrent && dCurrent - D == 1) {
					return "昨天";
				} else if (Y == yCurrent && M == mCurrent && dCurrent - D == 2) {
					return "前天";
				} else if (Y == yCurrent && M == mCurrent && dCurrent - D > 2) {
					return M + "月" + D + "日";
				} else if (Y == yCurrent && M < mCurrent) {
					return M + "月" + D + "日";
				} else if (Y < yCurrent) {
					return Y + "年" + M + "月" + D + "日";
				}

			},
		}
	}	
</script>

<style scoped>
	.fadeSetUp-enter-active,
	.fadeSetUp-leave-active {
		transition: opacity .5s;
	}

	.fadeSetUp-enter,
	.fadeSetUp-leave-to

	/* .fade-leave-active below version 2.1.8 */
		{
		opacity: 0;
	}

	/*搜索*/
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter,
	.fade-leave-to

	/* .fade-leave-active below version 2.1.8 */
		{
		opacity: 0;
	}

	.searchWrap {
		background: #FFFFFF;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 50px;
		z-index: 100;
	}

	.addsc {
		overflow: hidden;
		padding: 10px;
		border-bottom: #F1F1F1 1px solid;

	}

	.addsc span {
		float: left;
		font-weight: bold;
	}

	.addsc i {
		float: right;
		font-weight: bold;
		font-size: 20px;
		cursor: pointer;

	}








	/*显示隐藏tips*/
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter,
	.fade-leave-to

	/* .fade-leave-active below version 2.1.8 */
		{
		opacity: 0;
	}

	/**/
	.bounce-enter-active {
		animation: bounce-in .2s ease-out;
	}

	.bounce-leave-active {
		animation: bounce-in .2s reverse;
	}

	@keyframes bounce-in {
		0% {
			transform: scale(0);
		}

		100% {
			transform: scale(1);
		}
	}

	.loginShow {
		position: fixed;
		top: 50%;
		left: 50%;
		margin-left: -200px;
		margin-top: -260px;
		width: 400px;
		background: #FFFFFF;
		box-shadow: 1px 1px 50px rgba(0, 0, 0, .3);
		border-radius: 5px;
		overflow: hidden;
	}

	/* .wrapIM{
	position: fixed;
	top: 50%;
	left: 50%;
	margin-left: -400px;
	margin-top: -260px;
	width: 800px;
	height: 520px;
	background: #FFFFFF;
	padding-left: 270px;
	box-shadow: 1px 1px 50px rgba(0,0,0,.3);
	border-radius: 5px;
	z-index: 1000;
} */
	.wrapIM {
		position: fixed;
		top: 35%;
		left: 42.5%;
		margin-left: -400px;
		margin-top: -260px;
		width: 55%;
		height: 90%;
		background: #FFFFFF;
		padding-left: 270px;
		border-radius: 5px;
		z-index: 1000;
	}


	/* 设置滚动条的样式 */
	::-webkit-scrollbar {
		width: 5px;
	}

	/* 滚动槽 */
	::-webkit-scrollbar-track {
		border-radius: 10px;
	}

	/* 滚动条滑块 */
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background: #DFDFDF;
	}

	.wrapIMbg {
		position: fixed;
		top: 0%;
		left: 0%;
		width: 100%;
		height: 100%;
		background: #FFFFFF;
		padding-left: 270px;
		border-radius: 5px;
	}

	.left-userList {
		position: absolute;
		left: 0;
		top: 0;
		width: 270px;
		height: 100%;
		background: #FFFFFF;
		z-index: 100;
		border-right: 1px solid #F1F1F1;
		padding-top: 55px;
		overflow: hidden;
		padding-bottom: 10px;
		-moz-user-select: none;
		/* Firefox私有属性 */
		-webkit-user-select: none;
		/* WebKit内核私有属性 */
		-ms-user-select: none;
		/* IE私有属性(IE10及以后) */
		-khtml-user-select: none;
		/* KHTML内核私有属性 */
		-o-user-select: none;
		/* Opera私有属性 */
		user-select: none;
		/* CSS3属性 */

	}

	.left-userList .search {
		border-top: 1px solid #F1F1F1;
		position: relative;
		padding: 10px;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		z-index: 100;

	}

	.left-userList .search i {
		position: absolute;
		z-index: 1000;
		top: 0;
		right: 10px;
		color: #DFDFDF;
		outline: none;
	}

	.left-userList .search input {
		border: 1px solid #DFDFDF;
		height: 30px;
		border-radius: 4px;
		padding-left: 10px;
		width: 100%;
	}

	/*.left-userList ul{
	width: 100%;
	height: 100%;
	overflow: auto;
}
.left-userList ul li{
	   overflow: hidden;
}
.left-userList ul li .box{
	 position: relative;
    cursor: pointer;
    border-radius: 3px;
    white-space:nowrap;
    display: flex;
    padding: 16px;
}
.left-userList ul li .box img{
	width: 45px;
	height: 45px;
	border-radius: 100%;
	margin-right: 10px;
}
.left-userList ul li .box .ds{
	position: relative;
}
.left-userList ul li .box .ds h1{
	font-weight: normal;
	padding-bottom: 6px;
	font-size: 16px;
	overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
    word-break: normal !important;
    width: 120px;
}
.left-userList ul li .box .ds span{
	display: block;
	 width: 160px;
	overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
    word-break: normal !important;
    color: #888888;
}
.left-userList ul li .box .ds i{
	font-style: normal;
	position: absolute;
	top: 0;
	right: 0;
	 color: #888888;
}
.left-userList ul li .box.active{
	background: #F3F3F3;
}*/
	.right-userList {
		width: 100%;
		height: 100%;
		position: relative;
		padding-top: 110px;
		background: url(../../assets/img/im_bj.png) no-repeat;
		background-size: 100% 100%;
	}

	.top-userTitle {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 60px;
		/* background-color: rgba(245,245,245,.7); */
		cursor: move;
	}

	.top-userTitle {
		-moz-user-select: none;
		/* Firefox私有属性 */
		-webkit-user-select: none;
		/* WebKit内核私有属性 */
		-ms-user-select: none;
		/* IE私有属性(IE10及以后) */
		-khtml-user-select: none;
		/* KHTML内核私有属性 */
		-o-user-select: none;
		/* Opera私有属性 */
		user-select: none;
		/* CSS3属性 */

	}

	.top-userTitle .left {
		float: left;
		overflow: hidden;

	}

	.top-userTitle .left img {
		width: 46px;
		height: 46px;
		border-radius: 100%;
		margin-top: 7px;
		margin-left: 15px;
		float: left;


	}

	.top-userTitle .left span {
		float: left;
		font-size: 18px;
		line-height: 60px;
		padding-left: 10px;
		font-weight: bold;
	}

	.top-userTitle .right {
		float: right;
		overflow: hidden;
		padding-top: 6px;
		position: absolute;
		right: 0;
	}

	.top-userTitle .right ul {
		padding: 10px;
		overflow: hidden;
		cursor: context-menu;
	}

	.top-userTitle .right li {
		float: left;


	}

	.top-userTitle .right span {
		font-size: 18px;
		color: #333333;
		cursor: pointer;
		padding: 0px 4px;
	}

	.top-userTitle .right span:hover {
		color: #409EFF;
	}

	.top-userTitle span i {
		font-style: normal !important;
	}




	.center-userMsg {
		width: 100%;
		height: 100%;
		background-color: rgba(255, 255, 255, .9);
		position: relative;
	}

	.hdtp {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 100;
		background: #FFFFFF;
		padding: 40px;
	}

	.hdtp img {
		display: block;
		height: 100%;
		width: 100%;
		margin: auto;
		opacity: 0.8;
	}

	.bottom-textarea {
		position: absolute;
		left: 200px;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 140px;
		background-color: rgba(255, 255, 255, .9);
		border-top: 1px solid #F1F1F1;
	}

	.khb-icon {
		background: #409EFF;
		width: 80px;
		height: 80px;
		border-radius: 100%;
		text-align: center;
		line-height: 80px;
		cursor: pointer;
		position: fixed;
		right: 20px;
		bottom: 20px;
		z-index: 100;
	}

	.khb-icon span {
		color: #FFFFFF;
		font-size: 40px;

	}

	.tips {
		position: absolute;
		border-radius: 4px;
		padding: 10px;
		z-index: 2000;
		font-size: 12px;
		line-height: 1.2;
		min-width: 10px;
		word-wrap: break-word;
		background: #303133;
		color: #FFF;
		white-space: nowrap;
		right: 81px;
		top: 0;
	}

	.tips:after {
		content: '';
		height: 0;
		width: 0;
		overflow: hidden;
		font-size: 0;
		line-height: 0;
		border-color: transparent transparent transparent #303133;
		border-style: solid;
		border-width: 7px;
		position: absolute;
		right: -14px;
		bottom: 9px;
	}

	.box {
		width: 100%;
		height: 100%;
		overflow: auto;
	}

	.box .chatItem {
		position: relative;
		background: #FFFFFF;
		margin-bottom: 1px;
		padding: 10px 10px;
		padding-left: 70px;
		cursor: pointer;
		height: 50px;
		box-sizing: content-box;
		border-top: 1px solid #F1F1F1;
	}

	.unromves {
		float: right;
		margin-bottom: 5px;
		display: none;
		color: red;
		font-size: 12px;
	}

	.chatItem:hover .unromves {
		display: block;
	}

	.box .chatItem.active {
		background: #F3F3F3;
	}

	.box .chatItem .head {
		width: 45px;
		height: 45px;
		margin-right: 20px;
		position: absolute;
		left: 18px;
		background: #FFFFFF;
	}

	.box .chatItem .head .ig {
		position: absolute;
		width: 28px;
		height: 28px;
		left: -15px;
		top: -10px;
	}

	.box .chatItem .head img {
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}

	.box .chatItem .cont {
		flex-grow: 1;
		position: relative;
	}

	.box .chatItem .cont text {
		position: absolute;
		z-index: 200;
		padding: 0px 3px;
		display: inline-block;
		min-width: 8px;
		border-radius: 18px;
		background-color: #FA5151;
		color: #FFFFFF;
		text-align: center;
		vertical-align: middle;
		font-size: 20px;
		left: -45px;

	}

	.box .chatItem .cont .name {
		display: block;
		color: #333333;
		font-size: 16px;
		margin: 0;
	}

	.box .chatItem .cont .msg {
		display: block;
		color: #B7B7B7;
		font-size: 30px;
		margin: 0;
		font-size: 13px;
		padding-top: 5px;

		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		/*! autoprefixer: off */
		-webkit-box-orient: vertical;
		/* autoprefixer: on */
		word-break: break-all;



	}

	.box .chatItem .time {
		display: block;
		color: #B7B7B7;
		font-size: 12px;
		position: absolute;
		right: 10px;
		top: 10px;
	}

	.noNews {
		display: block;
		margin: auto;
		width: 82%;
		margin-top: 50px;
	}

	.addQun {
		width: 100%;
		height: 100%;
		overflow: auto;
	}

	.addQun ul {
		padding-bottom: 100px;
	}

	.addQun ul li {
		overflow: hidden;
		padding: 5px 10px;
		position: relative;
	}

	.addQun ul li img {
		width: 40px;
		height: 40px;
		border-radius: 4px;
		float: left;
	}

	.addQun ul li span {
		float: left;
		font-size: 16px;
		height: 40px;
		line-height: 40px;
		padding-left: 10px;
		display: block;
		width: 150px;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		word-break: break-all;
	}

	.addQun ul li button {
		position: absolute;
		background: #FFFFFF;
		border: none;
		border-radius: 3px;
		color: #555555;
		padding: 5px 10px;
		border: 1px #F1F1F1 solid;
		cursor: pointer;
		right: 10px;
		top: 10px;
		outline: none;
	}

	.khbIM {
		position: absolute;
		z-index: 10000;
	}

	.aibox {
		position: absolute;
		background: #FFF;
		z-index: 1000;
		width: 100%;
		height: 300px;
		border-top: 1px #DFDFDF solid;
		overflow: hidden;
	}

	.aiRon {
		display: flex;
		flex-wrap: wrap;
		max-height: 258px;
		overflow: auto;
	}

	.aiItemb {
		padding: 5px 0 !important;
		cursor: default !important;
	}

	.aiItem {
		text-align: center;
		padding: 20px 0;
		width: 25%;
		box-sizing: border-box;
		cursor: pointer;
		overflow: hidden;
	}
</style>


// WEBPACK FOOTER //
// src/components/im/khbIM.vue